<template>
  <aside v-if="MODE_DIAGNOSTIC" class="tm-diag">
    <menu>
      <i :class="{ t: show.mouse }" @mouseup.left="toggleShow($event, 'mouse')"
        >mouse</i
      >
      <i
        :class="{ t: show.tracks }"
        @mouseup.left="toggleShow($event, 'tracks')"
        >tracks</i
      >
      <i :class="{ t: show.other }" @mouseup.left="toggleShow($event, 'other')"
        >other</i
      >
    </menu>

    <tm-diag-point
      v-if="diagnosticEscort.tp1"
      :point="diagnosticEscort.tp1"
      :data-label="diagnosticEscort.tp1.time"
    />
    <tm-diag-mouse-point v-if="show.mouse" />
    <tm-diag-tracks v-if="show.tracks" />
    <tm-diag-other v-if="show.other" />
  </aside>
</template>

<script>
import { mapState } from 'vuex';
import tmDiagPoint from './tmDiagPoint.vue';
import tmDiagMousePoint from './tmDiagMousePoint.vue';
import tmDiagTracks from './tmDiagTracks.vue';
import tmDiagOther from './tmDiagOther.vue';

export default {
  name: 'tm-diag',
  components: {
    tmDiagPoint,
    tmDiagMousePoint,
    tmDiagTracks,
    tmDiagOther,
  },

  data() {
    return {
      show: {
        mouse: false,
        tracks: true,
        other: true,
      },
    };
  },

  computed: {
    ...mapState('timemachine', {
      diagnosticEscort: (state) => state.diagnosticEscort,
      MODE_DIAGNOSTIC: (state) => state.MODE.DIAGNOSTIC,
    }),
  },

  methods: {
    toggleShow(e, name) {
      e.stopPropagation();
      this.show[name] = !this.show[name];
    },
  },
};
</script>

<style lang="scss">
.tm-timemachine .tm-diag {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  pointer-events: none;

  > menu {
    margin: 0;
    padding: 0;
    display: flex;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: all;

    i {
      padding: 0 3px;
      &:hover {
        background-color: rgba(#000, 0.2);
        border-color: rgba(#000, 0.4);
      }
      &.t {
        font-weight: bold;
      }
    }
  }
}
</style>
